import $ from 'jquery';
import RecordAction from '../RecordAction';
import FeatureCardRepositioner from 'javascripts/feature_card_repositioner';
import type { Epic, Feature } from 'components/framework/models';
import type ApplicationModel from 'components/framework/ApplicationModel';

type RecordType = Feature | Epic;

export class MoveToBottomAction extends RecordAction<RecordType> {
  recordTypes = ['Feature', 'Epic'];

  get title() {
    return 'Move to bottom';
  }

  showForRecord(record: ApplicationModel): record is RecordType {
    return !!(
      super.showForRecord(record) &&
      // Don't show this for features/epics details view because the sorting can be set to other than rank
      !document.querySelector('.sidebar-layout__sidebar ') &&
      !window.currentProject?.isTeam &&
      record.releaseId &&
      record.referenceNum &&
      this.selectedRecords.every(
        r => r.releaseId === this.selectedRecords[0].releaseId
      )
    );
  }

  async runForRecords(records: RecordType[]) {
    const releaseId = records[0].releaseId;
    FeatureCardRepositioner.moveToBottom(
      releaseId,
      records.map(r => r.referenceNum)
    );
    for (const record of records) {
      const prefix = record.typename.toLowerCase();
      $(`#release_${releaseId},#master_release_${releaseId}`).append(
        $(`#${prefix}_${record.id}`)
      );
    }
  }
}
